module.exports = __webpack_public_path__ + "img/_Middle-Bevel-Attachment.2757fd2e.jpg";